import React from 'react';
import { Eye, Target } from 'lucide-react';
import { visionMission } from '../data/mock';

const VisionMissionSection = () => {
  return (
    <section className="py-24 bg-charcoal relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-burgundy/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-gold" />
            <span className="text-gold text-sm tracking-widest uppercase font-medium">
              Our Purpose
            </span>
            <div className="w-12 h-0.5 bg-gold" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-ivory">
            Vision & Mission
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Vision Card */}
          <div className="group p-10 bg-charcoal border border-slate/20 hover:border-gold/50 transition-all duration-500 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-burgundy to-gold transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            <div className="w-16 h-16 bg-burgundy/10 flex items-center justify-center mb-6 group-hover:bg-burgundy/20 transition-colors duration-300">
              <Eye className="text-gold" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-ivory mb-4">
              {visionMission.vision.title}
            </h3>
            <p className="text-slate text-lg leading-relaxed">
              {visionMission.vision.content}
            </p>
          </div>

          {/* Mission Card */}
          <div className="group p-10 bg-charcoal border border-slate/20 hover:border-gold/50 transition-all duration-500 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-burgundy transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            <div className="w-16 h-16 bg-burgundy/10 flex items-center justify-center mb-6 group-hover:bg-burgundy/20 transition-colors duration-300">
              <Target className="text-gold" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-ivory mb-4">
              {visionMission.mission.title}
            </h3>
            <p className="text-slate text-lg leading-relaxed">
              {visionMission.mission.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection;
